import { useState, useEffect } from 'react';

interface Notification {
  id: number;
  nombre: string;
  ciudad: string;
  accion: string;
  tiempo: string;
}

export default function LiveNotifications() {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const notificacionesData: Notification[] = [
    {
      id: 1,
      nombre: 'Juan Martínez',
      ciudad: 'Los Ángeles',
      accion: 'acaba de agendar su Consulta Normal',
      tiempo: 'Hace 2 minutos'
    },
    {
      id: 2,
      nombre: 'Sarah Johnson',
      ciudad: 'Nueva York',
      accion: 'reservó su Consulta en Inglés',
      tiempo: 'Hace 5 minutos'
    },
    {
      id: 3,
      nombre: 'Carlos Rodríguez',
      ciudad: 'Miami',
      accion: 'acaba de agendar su Consulta Urgente',
      tiempo: 'Hace 8 minutos'
    },
    {
      id: 4,
      nombre: 'Emma Williams',
      ciudad: 'San Francisco',
      accion: 'reservó su Consulta Normal',
      tiempo: 'Hace 12 minutos'
    },
    {
      id: 5,
      nombre: 'Miguel Ángel Torres',
      ciudad: 'Chicago',
      accion: 'acaba de agendar su Consulta Urgente',
      tiempo: 'Hace 15 minutos'
    },
    {
      id: 6,
      nombre: 'Lisa Anderson',
      ciudad: 'Austin',
      accion: 'reservó su Consulta Normal',
      tiempo: 'Hace 18 minutos'
    },
    {
      id: 7,
      nombre: 'Pedro Sánchez',
      ciudad: 'Houston',
      accion: 'acaba de agendar su Consulta en Inglés',
      tiempo: 'Hace 22 minutos'
    },
    {
      id: 8,
      nombre: 'Jennifer Lee',
      ciudad: 'Seattle',
      accion: 'reservó su Consulta Urgente',
      tiempo: 'Hace 25 minutos'
    },
    {
      id: 9,
      nombre: 'Roberto Fernández',
      ciudad: 'Boston',
      accion: 'acaba de agendar su Consulta Normal',
      tiempo: 'Hace 28 minutos'
    },
    {
      id: 10,
      nombre: 'Amanda Brown',
      ciudad: 'Denver',
      accion: 'reservó su Consulta en Inglés',
      tiempo: 'Hace 32 minutos'
    },
    {
      id: 11,
      nombre: 'Diego Ramírez',
      ciudad: 'Phoenix',
      accion: 'acaba de agendar su Consulta Urgente',
      tiempo: 'Hace 35 minutos'
    },
    {
      id: 12,
      nombre: 'Sophie Martin',
      ciudad: 'Portland',
      accion: 'reservó su Consulta Normal',
      tiempo: 'Hace 38 minutos'
    },
    {
      id: 13,
      nombre: 'Luis González',
      ciudad: 'San Diego',
      accion: 'acaba de agendar su Consulta Normal',
      tiempo: 'Hace 42 minutos'
    },
    {
      id: 14,
      nombre: 'Emily Davis',
      ciudad: 'Las Vegas',
      accion: 'reservó su Consulta Urgente',
      tiempo: 'Hace 45 minutos'
    },
    {
      id: 15,
      nombre: 'Antonio López',
      ciudad: 'Dallas',
      accion: 'acaba de agendar su Consulta en Inglés',
      tiempo: 'Hace 48 minutos'
    },
    {
      id: 16,
      nombre: 'Rachel Green',
      ciudad: 'Philadelphia',
      accion: 'reservó su Consulta Normal',
      tiempo: 'Hace 52 minutos'
    },
    {
      id: 17,
      nombre: 'Fernando Ruiz',
      ciudad: 'Atlanta',
      accion: 'acaba de agendar su Consulta Urgente',
      tiempo: 'Hace 55 minutos'
    },
    {
      id: 18,
      nombre: 'Olivia Taylor',
      ciudad: 'Nashville',
      accion: 'reservó su Consulta Normal',
      tiempo: 'Hace 58 minutos'
    },
    {
      id: 19,
      nombre: 'Javier Morales',
      ciudad: 'Orlando',
      accion: 'acaba de agendar su Consulta en Inglés',
      tiempo: 'Hace 1 hora'
    },
    {
      id: 20,
      nombre: 'Isabella White',
      ciudad: 'Charlotte',
      accion: 'reservó su Consulta Urgente',
      tiempo: 'Hace 1 hora'
    },
    {
      id: 21,
      nombre: 'Andrés Castillo',
      ciudad: 'Tampa',
      accion: 'acaba de agendar su Consulta Normal',
      tiempo: 'Hace 1 hora'
    }
  ];

  useEffect(() => {
    // Mostrar primera notificación al cargar
    setNotifications([notificacionesData[0]]);

    // Rotar notificaciones cada 20 segundos
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % notificacionesData.length;
        setNotifications([notificacionesData[nextIndex]]);
        return nextIndex;
      });
    }, 20000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed bottom-6 left-6 z-50 max-w-sm hidden lg:block">
      {notifications.map((notif) => (
        <div
          key={notif.id}
          className="bg-white rounded-xl shadow-2xl p-4 border-l-4 border-green-500 animate-slide-in-left"
        >
          <div className="flex items-start gap-3">
            <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0">
              <i className="ri-user-smile-line text-2xl text-green-600"></i>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <p className="text-xs text-green-600 font-semibold">EN VIVO</p>
              </div>
              <p className="text-sm font-bold text-gray-900 mb-1">
                {notif.nombre}
              </p>
              <p className="text-xs text-gray-600 mb-1">
                <i className="ri-map-pin-line text-blue-600"></i> {notif.ciudad}
              </p>
              <p className="text-sm text-gray-700">
                {notif.accion}
              </p>
              <p className="text-xs text-gray-500 mt-2">
                <i className="ri-time-line"></i> {notif.tiempo}
              </p>
            </div>
            <button
              onClick={() => setNotifications([])}
              className="text-gray-400 hover:text-gray-600 cursor-pointer"
            >
              <i className="ri-close-line text-lg"></i>
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
